import type { KeyboardEvent } from "react";

import { styled } from "styled-components";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

const HoverOverlay = styled.div`
    position: absolute;
    z-index: 10;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding: 16px;
    inset: 0 0 36px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease-in-out;
    background:
        linear-gradient(
            180deg,
            ${rgba(colorsPalettes.carbon[500], 0)} 0%,
            ${rgba(colorsPalettes.carbon[500], 0.4)} 100%
        ),
        linear-gradient(
            180deg,
            ${rgba(colorsPalettes.carbon[500], 0)} 50%,
            ${rgba(colorsPalettes.carbon[500], 0.4)} 100%
        ),
        linear-gradient(
            180deg,
            ${rgba(colorsPalettes.carbon[500], 0)} 55%,
            ${rgba(colorsPalettes.carbon[500], 0.2)} 80%,
            ${rgba(colorsPalettes.carbon[500], 0.8)} 120%
        );

    svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

interface IViewMoreOverlayProps {
    onClick?: (event: KeyboardEvent<HTMLDivElement>) => void;
}

export const ViewMoreOverlay = ({ onClick }: IViewMoreOverlayProps) => {
    const { translate } = useTranslate();

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            event.stopPropagation();
            onClick?.(event);
        }
    };

    return (
        <HoverOverlay
            data-overlay
            data-automation="view-more-overlay"
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            aria-label="View more details"
        >
            <Text
                fontVariant="button"
                color={colorsPalettes.carbon[50]}
            >
                {translate("activation.alerts.cards.social-post.view-more")}
            </Text>
        </HoverOverlay>
    );
};
